import { render, staticRenderFns } from "./generic_item.vue?vue&type=template&id=27be273e&scoped=true&"
import script from "./generic_item.vue?vue&type=script&lang=js&"
export * from "./generic_item.vue?vue&type=script&lang=js&"
import style0 from "./generic_item.vue?vue&type=style&index=0&id=27be273e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27be273e",
  null
  
)

export default component.exports